import { PdfTronFileOptions } from "lib/types/PdfTronFileOptions";
import {
  createContext,
  PropsWithChildren,
  use,
  useMemo,
  useState,
} from "react";

const PdfTronContext = createContext<ReturnType<typeof useProvider>>(null);

export const usePdfTron = () => use(PdfTronContext);

export const PdfTronProvider = ({ children, ...p }: PropsWithChildren<{}>) => {
  const value = useProvider();
  return <PdfTronContext value={value}>{children}</PdfTronContext>;
};

const useProvider = () => {
  const [fileOptions, setFileOptions] = useState<PdfTronFileOptions>(null);

  return useMemo(
    () => ({
      fileOptions,
      setFileOptions,
    }),
    [fileOptions],
  );
};
